import React from 'react';

const UserInfoDisplay = ({ userInfo, urlParams, teamsLoading, teamsError }) => {
  const isDebugMode = new URLSearchParams(window.location.search).get('debug') === 'true';
  
  if (!isDebugMode) return null;

  return (
    <div style={{ 
      background: '#f0f0f0', 
      padding: '1rem', 
      margin: '1rem 0', 
      borderRadius: '8px',
      fontSize: '0.9rem'
    }}>
      <h4>Debug Info (add ?debug=true to URL to show)</h4>
      <div><strong>Environment:</strong> Microsoft Teams</div>
      <div><strong>Teams Loading:</strong> {teamsLoading ? 'Yes' : 'No'}</div>
      <div><strong>Teams Error:</strong> {teamsError || 'None'}</div>
      <div><strong>URL Params:</strong> user={urlParams?.userId || 'null'}, tenant={urlParams?.tenantId || 'null'}</div>
      <div><strong>Teams Context:</strong> userId={userInfo?.userId || 'null'}, tenantId={userInfo?.tenantId || 'null'}</div>
      <div><strong>Display Name:</strong> {userInfo?.displayName || 'Not available'}</div>
    </div>
  );
};

export default UserInfoDisplay;